<template>
<div class="p-6 bg-indigo-800 min-h-screen flex flex-col justify-center items-center">
    <div class="w-full max-w-md">
    <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
    <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
            <h1 class="text-center font-bold text-3xl">Verification</h1>
            <div class="flex flex-wrap flex-col">
                <div class="mt-4">
                    <label for="first_name" class="form-label" >Your name</label>
                    <div class="form-input">{{ form.first_name}} {{ form.last_name}}</div>
                </div>

                <div class="mt-4" v-if="form.email">
                    <label for="email" class="form-label" >Email</label>
                    <div class="form-input">{{ form.email}}</div>
                </div>

                <div class="mt-4">
                    <label for="mobile" class="form-label" >Mobile</label>
                    <div class="form-input">{{ form.mobile}}</div>
                </div>
            </div>
            <div class="mt-4">
                <div v-if="!otp_sent" class="flex content-center flex-col">
                    <p class="text-sm text-gray-600 leading-normal my-4 text-center">
                        Your mobile number <b>+960 {{ form.mobile }}</b> needs to be verified.
                    </p>
                    <loading-button :loading="sending_otp" class="btn-primary" type="button" @click="sendMobileOTP">
                        <p class="text-center w-full">Send OTP Token</p>
                    </loading-button>
                </div>
                <div v-else>
                    <p class="text-sm text-gray-600 leading-normal my-4 text-center">
                        SMS with OTP sent to <b>+960 {{ form.mobile }}</b>.
                    </p>
                    <text-input required v-model="formData.token" :errors="$page.props.errors.token" autocomplete="one-time-code" class="my-4" label="Enter OTP token" type="number" maxLength="6" />
                    <div class="mt-4">
                        <loading-button :loading="sending" class="btn-primary" type="submit" @click="submit">Continue</loading-button>
                    </div>
                </div>
            </div>

        </div>

    </form>
</div>
</div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
  components: {LoadingButton, Logo, TextInput},

  props: {
    form: Object,
    autoSendOtp: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      sending: false,
      sending_otp: false,
      otp_url: null,
      otp_sent: null,
      formData: {
        token: null
      }
    }
  },

  mounted() {

    if(this.autoSendOtp) {
      this.sendMobileOTP();
    }

  },

  methods: {

    sendMobileOTP() {
      console.log('opt sent');
      this.sending_otp = true;
      this.$http.post(this.route('customer.ajax.registration.otp.request'), {
        mobile: this.form.mobile
      }).then((response) => {
        this.sending_otp = false
        this.otp_url = response.data.url
        this.otp_sent = new Date()
      })
    },

    submit() {
      this.sending_otp = true;
      this.$inertia.post(this.otp_url, this.formData).then(() => {
        this.sending_otp = false;
      })
    }
  }
}
</script>
